import {Injectable} from '@angular/core';
import {Category} from "../../dtos/vocab/category/category";
import {SystemicGrammarEntryDto} from "../../dtos/grammar/sys/systemic-grammar-entry-dto";
import {Word} from "../../dtos/vocab/entry/word";
import {TextTypeDto} from "../../dtos/text/text-type/text-type-dto";
import {References} from "../../dtos/references";
import {TextPatternCreationDto} from "../../dtos/text/text-pattern-dto";
import {Router} from "@angular/router";
import {VerbalActionEntryDto} from "../../dtos/verbal-action/entry/verbal-action-entry-dto";
import {CanDoStatementEntry} from "../../dtos/can-do-statement/entry/can-do-statement-entry";

@Injectable({
  providedIn: 'root'
})
export class SharedService {

  constructor() {
  }

  /**
   * returns the full category tree of a given category
   *
   * @param category
   */
  getCategoryTree(category: Category) {
    let s = category.name;
    while (category.parent !== null) {
      category = category.parent;
      s = category.name + ' \u2192 ' + s;
    }
    return s;
  }

  /**
   * show value in table
   * @param value can be an array or a string
   */
  show(value: string[] | string) {
    if (Array.isArray(value)) {
      return value.join(', ')
    } else {
      return value === "NONE" ? "Offen" : value
    }
  }

  /**
   * filters all null or empty arrays from a given entry
   * @param entry
   */
  filterNullOrEmpty(entry: References | SystemicGrammarEntryDto | Word | TextTypeDto | TextPatternCreationDto | VerbalActionEntryDto | CanDoStatementEntry) {
    return Object.entries(entry).filter(item => item[1] !== null && item[1].length !== 0);
  }

  getIds(array: any[]) {
    if(!array) return [];
    return array.map(item => item.id);
  }

  extractReferences(entry: SystemicGrammarEntryDto | Word | TextTypeDto | TextPatternCreationDto | VerbalActionEntryDto | CanDoStatementEntry) {
    // Extract references
    const references = new References(
      entry['vocabCategories'] || [],
      entry['vocabEntries'] || [],
      entry['functionalGrammarCategories'] || [],
      entry['functionalGrammarEntries'] || [],
      entry['systemicGrammarCategories'] || [],
      entry['systemicGrammarEntries'] || [],
      entry['textPatterns'] || [],
      entry['textTypes'] || [],
      entry['detailedCanDoStatementCategories'] || [],
      entry['detailedCanDoStatementEntries'] || [],
      entry['globalCanDoStatementCategories'] || [],
      entry['globalCanDoStatementEntries'] || [],
      entry['verbalActionCategories'] || [],
      entry['verbalActionEntries'] || []
    );
    // Clear original reference arrays
    [
      'vocabCategories', 'vocabEntries', 'functionalGrammarCategories', 'functionalGrammarEntries',
      'systemicGrammarCategories', 'systemicGrammarEntries', 'textPatterns', 'textTypes',
      'detailedCanDoStatementCategories', 'detailedCanDoStatementEntries',
      'globalCanDoStatementCategories', 'globalCanDoStatementEntries',
      'verbalActionCategories', 'verbalActionEntries'
    ].forEach(key => entry[key] = []);

    const allEmpty = Object.values(references).every(
      (arr) => Array.isArray(arr) && arr.length === 0
    );
    if (!allEmpty) {
      entry['Verweise'] = references;
    }
    return entry
  }

  /**
   * toggles all values to selected
   *
   * @param control a form control element
   * @param list of items which should be toggled inside the form control
   */
  toggleAllSelection(control, list) {
    control.patchValue([...list.map(item => item?.id), 0]);
  }


  toggleSelection(control, item) {
    control.patchValue([item?.id, 0]);
  }

  /**
   * used to remove the id c_id param from the url after reading it without triggering a reload for parameter
   * @param router
   */
  clearIdParam(router: Router): void {
    setTimeout(() => {
      router.navigate([], {
        queryParams: {id: null, c_id: null, type: null, flavor: null, q: null}, // set param to null → removes it
        queryParamsHandling: 'merge',                            // keep other params
        replaceUrl: true                                         // do not push to history
      });
    }, 25);
  }
}
